import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tenant } from '../../../model/tenant';
import { ActionButton } from '../../../model/ui/action-button';
import { Asset } from '../../../model/asset';
import { AssetFilters } from '../../../model/filters/asset-filters';
import { TenantsService } from '../../../services/tenants.service';
import { AssetsService } from '../../../services/assets.service';
import { SortOrder } from '../../../model/sort-order';
import { AssetRepresentation } from '../../../model/asset-representation';
import { SelectItem } from 'primeng/api';
import { Organization } from '../../../model/organization';

@Component({
  selector: 'app-asset-selector',
  templateUrl: './asset-selector.component.html',
  styleUrls: ['./asset-selector.component.scss']
})
export class AssetSelectorComponent {

  readonly DEFAULT_SORT_FIELD = 'alias';
  readonly DEFAULT_SORT_ORDER = 1;

  @Input() tenant: Tenant;
  @Input() organization?: Organization;
  @Input() actionButtons: ActionButton[];

  @Output() visibleChange: EventEmitter<boolean>;

  dialogVisible: boolean;
  assets: Asset[];
  totalAssets: number;
  loadingAssets: boolean;
  first: number;
  rows: number;
  representations: SelectItem<string>[];
  currentFilters: AssetFilters;
  selectedAsset: Asset;

  hasBeenOpened: boolean;

  constructor(private tenantsService: TenantsService,
              private assetsService: AssetsService) {
    this.visibleChange = new EventEmitter<boolean>();
    this.first = 0;
    this.rows = 10;
    this.currentFilters = new AssetFilters();
    this.currentFilters.sortField = this.DEFAULT_SORT_FIELD;
    this.currentFilters.sortOrder = this.DEFAULT_SORT_ORDER;
    this.loadingAssets = false;
    this.hasBeenOpened = false;
    this.assets = new Array(this.rows);
  }

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
    if (visible && !this.hasBeenOpened) {
      this.hasBeenOpened = true;
      this.loadAssets(0, this.rows);
      this.loadData();
    }
  }

  loadData(): void {
    this.currentFilters.tenantUuids = [this.tenant.uuid];
    this.loadAssetRepresentations();
  }

  applyFilters(): void {
    this.first = 0;
    this.loadAssets(this.first / this.rows, this.rows);
  }

  onAssetPageChange(event: any): void {
    if (this.hasBeenOpened) {
      this.currentFilters.sortField = event.sortField;
      this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
      this.loadAssets(event.first / event.rows, event.rows);
    }
  }

  private loadAssets(offset: number, limit: number): void {
    this.loadingAssets = true;
    this.currentFilters.tenantUuids = [this.tenant.uuid];
    if (this.organization) {
      this.currentFilters.organizationUuids = [this.organization.uuid];
    }
    this.assetsService.getAssets(offset, limit, this.currentFilters).subscribe(response => {
      this.assets = response.assets;
      this.totalAssets = response.totalElements;
      this.loadingAssets = false;
    });
  }

  private loadAssetRepresentations(): void {
    this.tenantsService.getTenantAssetRepresentations(this.tenant.uuid).subscribe(response => {
      const representationNames: string[] = response.assetRepresentations
        .map((representation: AssetRepresentation) => representation.name);
      const uniqueRepresentationNames = [...new Set(representationNames)];
      this.representations = uniqueRepresentationNames.sort()
        .map((value: string) => ({value}));
    });
  }

}
